<template>
  <div class="d-flex flex-column">
    <v-text-field
      v-model="selected.telegram"
      label="Telegram"
      outlined
      dense
      hide-details
      class="mb-5"
    ></v-text-field>
    <v-text-field
      v-model="selected.phone"
      label="Phone"
      outlined
      dense
      hide-details
      class="mb-5"
    ></v-text-field>

    <v-autocomplete
      v-model="selected.ambition"
      label="Ambition"
      outlined
      :items="[
        'Just need quite work',
        'Wants to work in Google',
        'Startups guy',
      ]"
      dense
      hide-details
      class="mb-5"
    ></v-autocomplete>

    <div class="d-flex mb-5">
      <v-text-field
        v-model="selected.preffered_rate"
        label="His preffered rate"
        outlined
        dense
        hide-details
        class="mr-4"
      ></v-text-field>
      <v-autocomplete
        v-model="selected.preffered_busyness"
        label="Preferred busyness"
        outlined
        dense
        hide-details
        multiple
        :items="[
          'Parttime',
          'Fulltime',
          'Microtime',
        ]"
      ></v-autocomplete>
    </div>

    <v-checkbox 
      v-model="selected.is_interviewed" 
      label="Interviewed?"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.is_busy" 
      label="Busy?"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.is_busy_with_our_project" 
      label="Busy in our project?"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.billing_disabled" 
      label="Disable billing"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.has_signed_consulting_agreement" 
      label="Has signed consulting agreement?"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.can_show_photo" 
      label="Can show photo?"
      hide-details
      class="ma-0"
    ></v-checkbox>
    <v-checkbox 
      v-model="selected.can_show_video_interview" 
      label="Can show video interview?"
      hide-details
      class="ma-0 mb-5"
    ></v-checkbox>
    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="selected.available_from"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="selected.available_from"
          label="Available from"
          prepend-icon="mdi-calendar"
          readonly
          clearable
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="selected.available_from"
        scrollable
      >
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="modal = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="$refs.dialog.save(selected.available_from)"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-dialog>

    <v-autocomplete
      v-model="selected.hubstaff_user_id"
      label="Hubstaff user"
      outlined
      :items="$store.getters['on-load/data']('hs-members')"
      item-text="name"
      item-value="id"
      dense
      hide-details
      class="mb-5"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      timezones: require('@/assets/timezones').default,
      modal: false,
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>

</style>